import React, { useState, useEffect, useContext } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { UserContext } from "../../context/UserContext";
import './Home.css';
import '../../App.css';
import WorkInProgress from '../../common/WorkInProgress/WorkInProgress';

import { TextField, Button, CardActions, Typography, Icon} from '@mui/material';
import {BASE_URL} from '../../baseUrl'


function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    //const [token, setToken] = useContext(UserContext);
  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn;
  const [UserBio, setUserBio] = useState({ });

  const navigate = useNavigate();

  const handleLogout = () => {
    //setToken(null);
    setLogin({ token: null, isLoggedIn: false });
    setUserBio(""); //Clear user data
    // Clear local storage
    localStorage.removeItem('tkn_2050');

    // Navigate back to home page or login page
    navigate('/');

  };

  const fetchUserData = () => {
    // Fetch user data and update UserBio state
    fetch(BASE_URL+ "/api/user/profile", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tkn_2050')}`, // Include the token in the headers
      },
    })
    .then(response => response.json())
    .then(data => {
      setUserBio(data.user);
    })
    .catch(error => console.error("Error fetching user data:", error));
  };
  
  
  // Call the fetchUserData function when the component mounts or when the user logs in
  useEffect(() => {
    if (isLoggedIn) {
      fetchUserData();
    }
  }, [isLoggedIn]);

/// handle click for dialog on "work in progress" section
const [open, setOpen] = useState(false);  
const handleClickOpen = () => {
    setOpen(true);
  };
const handleClose = () => {
    setOpen(false);
  };  



  return (

    <div>
    



{/* Section HOME */}

      <section className="home" id="home">


      <section className="home" id="home">

        <div className="content">
          <span className="hi"> Welcome to the</span>
          <h3><span> PLANNING </span> DASHBOARD </h3>
          <p className="info">
            Centralized Platform | Reporting progress
          </p>
          <p className="text">
            This platform has been created to fulfill The Planning Challenge, while incentivizing accountability, transparency and collaboration in the planning profession.
          </p>
          <p className="text">
            In this platform, cities and communities report what works and what doesn't to achieve their plans' goals in their own communities.
          </p>
          <a href="https://www.planningcommitment.org/challenge" className="btn"> About The Planning Challenge</a>
        </div>

        <div className="image">
          <img src="./images/Picture1.png" alt="" />
        </div>
      </section></section>

{/* Section ABOUT */}

      <section className="about" id="about">
        <h1 className="heading">DATA<span> ANALYTICS </span></h1>

        <div className="row-1">
          <div className="image">
          
            <img src="./images/8orgs.png" alt="" />
          </div>

          <div className="content">
            <h3>Systems Thinking & Collaboration</h3>
            <p>
              This Dashboard will serve as a centralized platform where data analytics and systems thinking overlap. Cities and Communities will be able to collaborate with best practices of planning to achieve success.
            </p>

            <div className="box-container">
              <div className="box">
                            

                <p><span> A new era of planning practice: </span> 
                  <p>As we enter a new era of big data, data analytics must become a core pillar of the planning profession. By harnessing data to track performance, identify trends, and measure impact, planners can make more informed, equitable, and sustainable decisions. Equally important is the sharing of best practices and lessons learned across jurisdictions. This initiative invites cities and communities to become part of a collaborative network—one that values transparency, embraces innovation, and leverages the power of data to drive collective progress.</p>
                </p>
                <p><span> Disciplines involved: </span> Planning, Architecture, Landscape Architecture, Urban Design, Civil Engineering, Education, and more...</p>
              </div>
            </div>
            <Link to="/login" className="btn">Explore the Dashboard</Link>
            <Link to="/sign-up" className="btn">Become a signatory</Link>
            
          </div>
        </div>

        {/*
        <h1 className="heading"><span> PLG2050 </span> numbers </h1>

        <div className="row-2">
          <div className="skills">
            <div className="progress">
              <h3>Strategic goals progress (2022, 2023, 2024) <span> 65% </span></h3>
              <div className="bar"><span></span></div>
            </div>
            <div className="progress">
              <h3>Target amount of goals and metrics (2022, 2023, 2024) <span> 37% </span></h3>
              <div className="bar"><span></span></div>
            </div>
            <div className="progress">
              <h3>International involvement and recognition <span> 75% </span></h3>
              <div className="bar"><span></span></div>
            </div>
            <div className="progress">
              <h3>US involvement and recongnition <span> 85% </span></h3>
              <div className="bar"><span></span></div>
            </div>
          </div>
        
        <div className="box-container">
          <div className="box">
            <h3>7</h3>
            <p>Voluntary Signatories</p>
          </div>
          <div className="box">
            <h3> 57+</h3>
            <p>Metrics uploaded</p>
          </div>
          <div className="box">
            <h3> 111+</h3>
            <p>Members of the Development Working Group</p>
          </div>
          <div className="box">
            <h3> 7+</h3>
            <p>Industries & Built-environment Professions / Sectors</p>
          </div>
        </div>
        </div>
        */}
      </section>

{/* Section OUR TOOL */}
   
      <section className="tool" id="tool">

      <h1 className="heading">
                <div> 
                <div className='break'> </div> 
                </div>
      
        <span> OUR </span> TOOL</h1>

        <div className="box-container">
          <div className="box">
            <i className="fas fa-user-plus"></i>
            <h3>Join</h3>
            <p>
              You don't need to be a signatory to join the network and use the tool. It is free to join! Generate your user credentials.
            </p>
            <Link to="/sign-up" className="btn">New user</Link>

          </div>
        <div className="box">
          <i className="fas fa-bullseye"></i>
          <h3>Upload & Map your Strategy</h3>
          <p>
            Does your city / community have a strategic action or strategy to achieve certain outcomes by 2030 or anytime in the future?
          </p>
          <p>
            Explore the whole database, and connections to UN SDGs
          </p>
          <Link to ="/ScatterPBI" className="btn"> Explore the database </Link>
        </div>

        <div className="box">
          <i className="fas fa-signal"></i>
          <h3>Report your progress</h3>
          <p>
            If you already mapped your goal / action / strategy, click here to report your progress to date.
          </p>
          <Link to="../Strategies/MyStrategiesPage" className="btn">Report your progress</Link>
        </div>
      </div>
    </section>
    
{/* Section CITIES AND COMMUNITIES */}
<section className="CNC" id="CNC">
      <h1 className="heading">
                <div> 
                <div className='break'> </div> 
                </div>
               
        <span> OUR </span> CITIES & COMMUNITIES</h1>

      <div className="box-container">
        <div className="box">
          <div className="content">
            <span> Foundation 2022 - 2025 </span>
            <h3>Signatories</h3>
            <p>
              Early adopters include: City of Las Vegas-Nevada, Mid-Ohio Regional Planning Commission, RCE North Texas, Eastern New Mexico University, City of Upper Arlington- Ohio, IMP (Instituto Metropolitano de Planeamiento) - Peru, Downtown Austin Alliance (Austin, TX), Midland Downtown Master Plan (Midland, TX).           </p>
              <Link to="/sign-up" className="btn">Become a Signatory</Link>
          </div>
        </div>

        <div className="box">
          <div className="content">
            <span> Foundation 2022 - 2025 </span>
            <h3>Advisory Board <br></br>(2022-2023)</h3>
            <p>
              Individuals representing professional organizations (APA SCD, CNU, USGBC, AIA, ISI):<br></br> 
              Merrill St Leger, Rick Cole, Vatsal Bhatt, Carlton Hart, Anthony Kane.
            </p>
            <Link to="https://planningcommitment.org/about/" className="btn">Learn more...</Link>
          </div>
        </div>

        <div className="box">
          <div className="content">
            <span> Foundation 2022 - 2025 </span>
            <h3>Development Working Group (DWG)</h3>
            <p>
              Our Development Working group deserves recognition. These volunteers helped shape this dashboard platform since its inception. 
              Over 111 professionals have supported the initiative in various ways.
            </p>
            <Link to="https://planningcommitment.org/resource_hub/" className="btn">Become part of the DWG</Link>
          </div>
        </div>

        <div className="box">
          <div className="content">
            <span> 2024 </span>
            <h3>Leadership Cohort</h3>
            <p>
              Individuals contributing and introducing cities and communities to become signatories.
            </p>
            <p>Email info@planningcommitment.org to become one of the leaders of this initiative!</p>
            <Link to="mailto:info@planningcommitment.org" className="btn">Connect Now</Link>
          </div>
        </div>

        <div className="box">
          <div className="content">
            <span> Foundation 2022-2025 </span>
            <h3>Advisory Board <br></br>(2024-2025)</h3>
            <p>
              Individuals representing professional organizations (APA SCD, CNU, USGBC, AIA, ISI):<br></br> 
              Karla Ebenbach, Heyden Walker, Vatsal Bhatt, Carlton Hart, Anthony Kane.<br></br>
              International Advisory Members:<br></br>
              Eleanor Mohammed, Jua Cillers, Bruno Marquez, Pietro Elisei, Elisabeth Belpaire.
            </p>
            <Link to="https://planningcommitment.org/about/" className="btn">Learn more...</Link>
          </div>
        </div>

        <div className="box">
          <div className="content">
            <span> 2025</span>
            <h3>Kick-off cohort</h3>
            <p>
              Leaders in diverse industries supporting the first year of tracking commitments, and supporting the addition of signatories
            </p>
            <p>Email info@planningcommitment.org to become one of the leaders of this initiative!</p>
            <Link to="mailto:info@planningcommitment.org" className="btn">Your name here...</Link>
          </div>
        </div>
      </div>
    </section>

{/* Section NETWORK */}
    <section className="network" id="network">
      <h1 className="heading">
                <div> 
                <div className='break'> </div> 
                </div> 
        
        
        <span> OUR </span> NETWORK</h1>

      <div className="box-container">
        <div className="box">
          <img src="./images/signatories.png" alt="" />
          <h3>SIGNATORIES</h3>
          <div className="icons">
            <Link to="#" className="fas fa-link" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
            <Link to="#" className="fas fa-share" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
            <Link to="#" className="fas fa-search" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
          </div>
        </div>

        <div className="box">
          <img src="./images/nonsignat.png" alt="" />
          <h3>NON SIGNATORIES</h3>
          <div className="icons">
            <Link to="#" className="fas fa-link" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
            <Link to="#" className="fas fa-share" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
            <Link to="#" className="fas fa-search" onClick={handleClickOpen}></Link>
            <WorkInProgress open={open} handleClose={handleClose} />
          </div>
        </div>
        </div>
     </section>  

{/* Section CONTACT US */}
<section className="contact" id="contact">
      <h1 className="heading">CONTACT <span> US </span></h1>

      <div className="icons-container">
        <div className="icons">
          <i className="fas fa-envelope"></i>
          <h3>Email address</h3>
          <a className='text' >Email us directly or fill in the contact form below<br></br></a>
          <a className='email-link' href="mailto:info@planningcommitment.org">info@planningcommitment.org</a>

          
        </div>

        <div className="icons">
          <i className="fas fa-phone"></i>
          <h3>Number</h3>
          <svg xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" viewBox="0 0 77 77"><path fill="#fff" d="M5 17h62v38H5z"></path><path fill="#d22f27" d="M5 17h62v5H5zm0 9h62v4H5zm0 8h62v4H5z"></path><path fill="#1e50a0" d="M5 17h32v21H5z"></path><path fill="#d22f27" d="M5 42h62v4H5z"></path><circle cx={9} cy={22} r={1.75} fill="#fff"></circle><circle cx={17} cy={22} r={1.75} fill="#fff"></circle><circle cx={25} cy={22} r={1.75} fill="#fff"></circle><circle cx={33} cy={22} r={1.75} fill="#fff"></circle><circle cx={29} cy={26} r={1.75} fill="#fff"></circle><circle cx={21} cy={26} r={1.75} fill="#fff"></circle><circle cx={13} cy={26} r={1.75} fill="#fff"></circle><circle cx={9} cy={30} r={1.75} fill="#fff"></circle><circle cx={17} cy={30} r={1.75} fill="#fff"></circle><circle cx={25} cy={30} r={1.75} fill="#fff"></circle><circle cx={33} cy={30} r={1.75} fill="#fff"></circle><circle cx={29} cy={34} r={1.75} fill="#fff"></circle><circle cx={21} cy={34} r={1.75} fill="#fff"></circle><circle cx={13} cy={34} r={1.75} fill="#fff"></circle><path fill="#d22f27" d="M5 50h62v5H5z"></path><path fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 17h62v38H5z"></path></svg>
          <Typography className='text'>+1 75.PLG2050.1</Typography>
          <Typography className='text'>(+1 757-542-0501)</Typography>
          
        </div>

        <div className="icons">
          <i className="fas fa-map-marker-alt"></i>
          <h3>Address</h3>
          <Typography className='text'> 11902 Burnet Rd, Suite 101. <br></br>Austin, TX. 78757</Typography>
        </div>
      </div>

      

      <div className="row">
        <form action="">
          <TextField type="text" placeholder="YOUR NAME" className="box" />
          <TextField type="email" placeholder="YOUR EMAIL ADDRESS" className="box" />
          
          <TextField
            multiline
            rows={4}
            placeholder="Enter your message here"
            fullWidth
            style={{marginBottom: '2rem', fontVariant: 'all-petite-caps', fontSize: 'xx-small' }}
          ></TextField>

        <CardActions sx={{
                    '& .MuiButton-text' : {color: 'var(--main-color)'},
                    '& .MuiButtonBase-root' : {border: '1px solid var(--main-color)', background: "var(--main-color)"},
                  }} >
          <Button fullWidth variant='contained'> Send message </Button> 
        </CardActions>
        </form>

        <iframe
          className="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3441.0425624700765!2d-97.71893472361813!3d30.40653427474331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cc12458f0f21%3A0x1c36593b8b96ebb1!2sDomain%20Point%201!5e0!3m2!1sen!2sus!4v1703303150038!5m2!1sen!2sus"
          allowfullscreen=""
          loading="lazy"
          
        ></iframe>
      </div>
    </section>
    
  </div>


    
  );
}


export default Home;

